import React from 'react';
import { Box, Typography } from '@mui/material';

export const EmptyState: React.FC = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "236px",
      bgcolor: "background.paper",
      border: "1px solid",
      borderColor: "divider",
      borderRadius: "16px",
    }}
  >
    <Typography variant="body2" color="text.secondary">
      No calls are scheduled
    </Typography>
  </Box>
);
